angular.module('global.validation.model', [

    /*Validation Model*/

]).service('ValidationModel', [function () {

        var model = this;

        function getFieldClass(fieldName, formErrors) {
            return formErrors[fieldName] != null ? 'formError' : '';
        }

        model.getFieldClass = function (fieldName, fieldValue, formErrors, isTypingInProgress) {
            if (isTypingInProgress || isEmpty(fieldValue)) {
                return "";
            }
            var fieldClass = getFieldClass(fieldName, formErrors);
            if (fieldClass != "formError" && !isEmpty(fieldValue)) {
                fieldClass = "formSuccess";
            } else if (fieldClass == "formError") {
                fieldClass = "formError";
            }
            return fieldClass;
        };

        model.validateEmail = function (email, formErrors) {
            if (!isEmail(email)) {
                formErrors["email"] = "invalidEmail";
                return false;
            }
            delete formErrors["email"];
            return true;
        };

        model.validateFullName = function (name, formErrors) {
            if (isEmpty(name)) {
                formErrors["fullName"] = "invalidFullName";
                return false;
            }
            delete formErrors["fullName"];
            return true;
        };

        model.validatePasswordAndLength = function (password, minPasswordLength, formErrors, fieldName) {
            if (minPasswordLength == null) {
                minPasswordLength = 6;
            }

            if (!fieldName) {
                fieldName = "password";
            }

            if (isEmpty(password)) {
                formErrors[fieldName] = "invalidPassword";
                return false;
            }

            if (password.length < minPasswordLength) {
                formErrors[fieldName] = "passwordTooShort";
                return false;
            }

            delete formErrors[fieldName];
            return true;
        };

        model.validatePassword = function (password, formErrors) {
            if (!isValidLength(password)) {
                formErrors["password"] = "invalidPassword";
                return false;
            }
            delete formErrors["password"];
            return true;
        };

        model.validateSignInPassword = function (password, formErrors) {
            if (isEmpty(password)) {
                formErrors["password"] = "invalidPassword";
                return false;
            }
            delete formErrors["password"];
            return true;
        };

        model.validateConfirmPassword = function (password, confirmPassword, formErrors) {
            if (password != confirmPassword) {
                formErrors["confirmPassword"] = "passwordsDontMatch";
                return false;
            }
            delete formErrors["confirmPassword"];
            return true;
        };

        model.validateConfirmEmail = function (email, confirmEmail, formErrors) {
            if (confirmEmail != email) {
                formErrors["confirmEmail"] = "emailsDontMatch";
                return false;
            }
            delete formErrors["confirmEmail"];
            return true;
        };

        model.validateCreditCardNumber = function (creditCardNumber, formErrors) {
            var validCard = $.payment.validateCardNumber(creditCardNumber);
            if (!validCard) {
                formErrors["creditCardNumber"] = "invalidCreditCardNumber";
                return false;
            }
            delete formErrors["creditCardNumber"];
            return true;
        };
        model.validateCreditCardExpiration = function (creditCardExpiration, formErrors) {
            if (!creditCardExpiration) {
                return false;
            }
            var cardExpiryVal = $.payment.cardExpiryVal(creditCardExpiration);
            if (cardExpiryVal == null || isNaN(cardExpiryVal.month) || isNaN(cardExpiryVal.year)) {
                return false;
            }
            var validCardExp = $.payment.validateCardExpiry(cardExpiryVal.month, cardExpiryVal.year);
            if (!validCardExp) {
                formErrors["creditCardExpiration"] = "invalidCreditCardExpiration";
                return false;
            }
            delete formErrors["creditCardExpiration"];
            return true;
        };

        model.validateCreditCardCvc = function (cvc, formErrors) {
            var validCvc = $.payment.validateCardCVC(cvc);
            if (!validCvc) {
                formErrors["creditCardCvc"] = "invalidCreditCardCvc";
                return false;
            }
            delete formErrors["creditCardCvc"];
            return true;
        };

        model.validateCreditCardZip = function (zip, formErrors) {
            if (zip == null || zip.trim() == "") {
                formErrors["creditCardZip"] = "invalidCreditCardZip";
                return false;
            }
            delete formErrors["creditCardZip"];
            return true;
        };

        model.validateCreditCardPromo = function (promo, formErrors) {
            if (promo == null || promo.trim() == "") {
                formErrors["creditCardPromo"] = "invalidCreditCardPromo";
                return false;
            }
            delete formErrors["creditCardPromo"];
            return true;
        }
    }]
);